import { SET_CONFIRM_PASSCODE_MODAL_VISIBILITY, SET_PASSCODE_VERFICATION } from '../actions/type';

function setVisibilityPasscode(visibility) {
  return {
    type: SET_CONFIRM_PASSCODE_MODAL_VISIBILITY,
    payload: visibility,
  };
}

function passcodeVerification(verified) {
  return {
    type: SET_PASSCODE_VERFICATION,
    payload: verified,
  };
}

export const setConfirmPasscodeModalVisibility = (visibility) => {
  return dispatch => {
    dispatch(setVisibilityPasscode(visibility));
  }
}

export const handleVerifyPasscodeResult = verified => {
  return dispatch => {
    dispatch(setVisibilityPasscode());
    if (verified) {
      dispatch(passcodeVerification(verified));
    }
  }
}

export const setPasscodeVerificationStatus = verified => {
  return dispatch => {
    dispatch(passcodeVerification(verified))
  }
}




// WEBPACK FOOTER //
// ./master/jsx/actions/baseModal_actions.js